// extracted by mini-css-extract-plugin
export default {"FieldAssistance":"FieldAssistance-module--FieldAssistance--6WG97"};